(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/wager.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/wager.js'); 'use strict';

var getMarketplaceAccount = svs.tipset.helpers.getMarketplaceAccount;
var _svs$components$sport = svs.components.sport,
    getPaymentDoneMessage = _svs$components$sport.getPaymentDoneMessage,
    getPaymentConfirmMessage = _svs$components$sport.getPaymentConfirmMessage;
var userIsParticipatingInTipsSM = svs.competition.Helper.userIsParticipatingInTipsSM;
var getTeamUrl = svs.components.marketplace.helpers.getTeamUrl;
svs.tipset.models.Wager = Backbone.Model.extend({
  log: new svs.core.log.Logger('svs.tipset.models.Wager'),
  defaults: {
    id: 0,
    bagType: 0,
    crc: 0,
    marketInfo: 0,
    drawNum: null,
    sportkryss: null,
    rowPriceMulti: 1
  },
  AUTHENTICATED_SAM_NOT_ASM: 3107,
  NOT_AUTHENTICATED: 100005,
  SALES_STOPPED: 8124,
  REG_BET_REJECTED: 8105,
  CUST_MAX_BOARDS_IN_DRAW: 8239,
  startPaying: function startPaying() {
    this.set('id', svs.tipset.models.gameDefinitions.getAPIName(svs.tipset.collections.draws.getCurrentDraw().get('productId')), {
      silent: true
    });

    if (svs.tipset.models.play && !svs.tipset.models.play.get('isTransferWager') && this.get('id') != 'T8' && this.get('id') != 'POWERPLAY') {
      if (!svs.tipset.models.transferWager) {
        svs.tipset.models.transferWager = new svs.tipset.models.TransferWager();
        this.listenToOnce(svs.tipset.models.transferWager, 'change:hasDrawToTransferTo', this.pay);
      } else {
        this.pay();
      }
    } else {
      this.pay();
    }
  },
  pay: function pay() {
    var _this = this;

    this.log.debug('pay', this);
    var wagerToPay = this.getWager();
    var wagerProps = this.getWagerProps();
    var isPowerplay = this.getProductName() === svs.tipset.constants.PRODUCTNAME.POWERPLAY; 

    var isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;

    if (isSelfService) {
      var wagers = [];
      wagers.push(wagerToPay);

      if (isPowerplay && svs.tipset.models.bombenXperten && svs.tipset.models.bombenXperten.get('hasXpertValues')) {
        wagers.push(svs.tipset.models.bombenXperten.getBombenWager());
      }

      svs.components.selfservice.container.open(wagers, false, function () {
        _this.clearLocalStorage();
      }, function () {});
    } else {
      svs.lbUtils.wager.pay(wagerToPay, wagerProps, function (data) {
        svs.events.publish('/loader/show');

        var notificationWager = _this.getWager(),
        bets = notificationWager.bets.filter(function (bet) {
          return bet.numDraws === 1 && !bet.productId.match(/joker/i);
        }),
        draws = bets.map(function (bet) {
          return svs.tipset.collections.draws.getDrawById(bet.drawNum);
        }),
        roomKeys = draws.map(function (draw) {
          return draw.get('roomKeys');
        }),
            productId = draws.length > 0 ? draws[0].get('productId') : 0,
            wagerSerial = data.wagerClientSerial;

        if (roomKeys.length > 0) {
          roomKeys.forEach(function (roomKey) {
            svs.components.app_notifications.setUpAppNotifications({
              productId: productId,
              wagerSerial: wagerSerial,
              roomKeys: roomKey
            });
          });
        }

        var competition = svs.tipset.models.competition;

        if (competition && competition.getIsPayingCompetition()) {
          if (svs.utils.ns.isNamespace('svs.competition.core.data.participatedSMDraws') && Array.isArray(svs.competition.core.data.participatedSMDraws)) {
            svs.competition.core.data.participatedSMDraws.push(svs.tipset.collections.draws.getCurrentDraw().get('drawNumber'));
          }

          competition.setIsPayingCompetition(true);
        }

        _this.log.debug("success (".concat(JSON.stringify(data), ")"));

        var amount;

        if (data.CreateWagerReply) {
          amount = svs.utils.format.CurrencyFromJupiterString(data.CreateWagerReply.betAmount);
        } else if (data.wager) {
          amount = svs.utils.format.CurrencyFromJupiterString(data.wager.wagerAmounts.betAmount);
        } else {
          amount = svs.utils.format.CurrencyFromJupiterString(data.wagerAmounts.betAmount);
        }

        if (isPowerplay && svs.tipset.models.bombenXperten && svs.tipset.models.bombenXperten.get('hasXpertValues')) {
          svs.events.publish('/loader/show');

          _this.log.debug('payBet()-Bomben');

          var wager = svs.tipset.models.bombenXperten.getBombenWager();
          var wagerprops = {
            productId: 'Bomben'
          };

          _this.log.debug(JSON.stringify(wager));

          svs.lbUtils.wager.pay(wager, wagerprops, function (data) {
            var draw = svs.tipset.collections.bombenDraws.getBombenDrawByDrawNumber(svs.tipset.collections.draws.getCurrentDraw().get('bombenDrawNum'));

            if (draw.roomKeys && draw.roomKeys.keys && draw.roomKeys.keys.length > 0) {
              svs.components.app_notifications.setUpAppNotifications({
                productId: draw.productId,
                wagerSerial: data.wagerClientSerial,
                roomKeys: draw.roomKeys
              });
            }

            _this.log.debug("success (".concat(JSON.stringify(data), ")"));

            var bombenAmount;

            if (data.wager) {
              bombenAmount = svs.utils.format.CurrencyFromJupiterString(data.wager.wagerAmounts.betAmount);
            } else {
              bombenAmount = svs.utils.format.CurrencyFromJupiterString(data.wagerAmounts.betAmount);
            }

            _.defer(function () {
              svs.tipset.models.wager.paymentDone(amount, bombenAmount);
            });
          }, function (response) {
            var errCodestr = String(response.error.code);
            var errCode = parseInt(errCodestr.replace(/\s/g, ''), 10);
            var errMessage;
            var title;
            var mpErrorCodeHandler = getMarketplaceAccount() && svs.components.marketplaceData.errorCodeHandler;

            switch (errCode) {
              case _this.AUTHENTICATED_SAM_NOT_ASM:
                svs.core.userSession.logout();
                title = 'Du måste logga in för att lägga ditt spel';
                break;

              case _this.NOT_AUTHENTICATED:
                title = 'Du måste logga in för att lägga ditt spel';
                break;

              case _this.SALES_STOPPED:
                title = 'Ditt spel på Bomben är stängt just nu';
                errMessage = 'Försök senare';
                break;

              case _this.REG_BET_REJECTED:
                if (response.error.message.indexOf('DEFINED') > 0) {
                  title = 'Ditt spel på Bomben har inte öppnat än';
                  errMessage = 'Försök senare när det har öppnat för spel.';
                } else {
                  title = 'Ditt spel på Bomben har stängt';
                }

                break;

              case _this.CUST_MAX_BOARDS_IN_DRAW:
                title = 'Din insats på Bomben är tyvärr inte godkänd';
                errMessage = 'Högsta tillåtna insats, 60000 kr per omgång, har passerats.';
                break;

              default:
            } 


            if (!errMessage && !title) {
              if (mpErrorCodeHandler) {
                mpErrorCodeHandler.getErrorMessage(errCode, function (error) {
                  svs.sport.sport_common.showErrorDialog('Nu gick något fel', error.message);
                }, {
                  shouldCheckPlayerExclusions: true
                });
              } else {
                svs.accountservices.player_exclusions.hasExclusionOnVertical('sport', function (data) {
                  if (data && data.hasExclusions) {
                    svs.sport.sport_common.showErrorDialog('Du har en aktiv spelpaus', data.exclusionInfo);
                  } else {
                    svs.sport.sport_common.showErrorDialog('Tekniskt fel', 'Försök igen senare.');
                  }
                });
              }
            } else {
              svs.sport.sport_common.showErrorDialog(title, errMessage);
            }
          });
        } else {
          _.defer(function () {
            svs.tipset.models.wager.paymentDone(amount, null, getMarketplaceAccount());
          });
        }
      }, function (response) {
        var errCodestr = String(response.error.code);
        var errCode = parseInt(errCodestr.replace(/\s/g, ''), 10);
        var errMessage, errTitle;
        var mpErrorCodeHandler = getMarketplaceAccount() && svs.components.marketplaceData.errorCodeHandler;

        switch (errCode) {
          case 55:
          case 72:
            errMessage = "Laget f\xE5r inte spela f\xF6r mer \xE4n ".concat(svs.utils.format.Currency(svs.tipset.models.gameDefinitions.getMarketplaceLimits(svs.tipset.models.gameDefinitions.getProductId(_this.get('id')))), " kr p\xE5 samma spelomg\xE5ng.");
            errTitle = 'Det gick inte att betala';
            break;

          case _this.AUTHENTICATED_SAM_NOT_ASM:
            svs.core.userSession.logout();
            errTitle = 'Du måste logga in för att lägga ditt spel';
            break;

          case _this.NOT_AUTHENTICATED:
            errTitle = 'Du måste logga in för att lägga ditt spel';
            break;

          case _this.SALES_STOPPED:
            errTitle = 'Omgången är stängd för spel';
            errMessage = 'Försök senare';
            break;

          case _this.REG_BET_REJECTED:
            if (response.error.message.indexOf('DEFINED') > 0) {
              errTitle = 'Omgången har inte öppnat för spel än';
              errMessage = 'Försök senare';
            } else {
              errTitle = 'Omgången har stängt';
            }

            break;

          default:
        } 


        if (!errMessage) {
          if (mpErrorCodeHandler) {
            mpErrorCodeHandler.getErrorMessage(errCode, function (error) {
              svs.sport.sport_common.showErrorDialog('Nu gick något fel', error.message);
            }, {
              shouldCheckPlayerExclusions: true
            });
          } else {
            svs.accountservices.player_exclusions.hasExclusionOnVertical('sport', function (data) {
              if (data && data.hasExclusions) {
                svs.sport.sport_common.showErrorDialog('Du har en aktiv spelpaus', data.exclusionInfo);
              } else {
                svs.sport.sport_common.showErrorDialog('Tekniskt fel', 'Försök igen senare.');
              }
            });
          }
        } else {
          svs.sport.sport_common.showErrorDialog(errTitle, errMessage);
        }

        _this.log.debug("Error in payment: ".concat(response.error.code, ": ").concat(response.error.message));
      });
    }
  },
  paymentDone: function paymentDone(amount, bombenAmount, marketplaceAccount) {
    this.wagerToTransfer = this.getWager();
    svs.events.publish('/loader/hide');

    if (svs.tipset.data.competition) {
      svs.tipset.data.competition = undefined;
    }

    var competition = svs.tipset.models.competition;

    if (competition && competition.getIsPayingCompetition()) {
      svs.events.publish('/tipset/paySucess', {
        drawNumber: svs.tipset.collections.draws.getCurrentDraw().get('drawNumber')
      });
    }

    svs.components.marketplace.accountSelector.helpers.fetchGames({
      drawNumber: svs.tipset.collections.draws.getCurrentDraw().get('drawNumber'),
      productId: svs.tipset.collections.draws.getCurrentDraw().get('productId')
    });
    this.clearLocalStorage(function () {
      svs.tipset.models.wager.showPayConfirmation(amount, bombenAmount, marketplaceAccount);
    });
  },
  clearLocalStorage: function clearLocalStorage(confirmationCallback) {
    svs.tipset.objects.localstorageHandler.clearLocalStorage({
      callback: function callback() {
        var url = '';
        var afterGameTab = 'relaterat',
            hasRelatedTab = svs.tipset.data.tabs.some(function (tab) {
          return tab.anchor === afterGameTab && tab.active === true;
        });

        if (hasRelatedTab) {
          url = "?flik=".concat(afterGameTab);
        }

        svs.obj.router.navigate(url, {
          trigger: true
        });

        if (confirmationCallback) {
          confirmationCallback();
        }
      }
    });
  },
  showPayConfirmation: function showPayConfirmation(amount, bombenAmount, marketplaceAccount) {
    var _this2 = this;

    var competition = svs.tipset.models.competition;
    var compDesc = competition && competition.getIsPayingCompetition() ? competition.getCompDesc() : '';
    var competitionSignUp = competition && userIsParticipatingInTipsSM();
    var marketplaceUrl = '';

    if (marketplaceAccount) {
      marketplaceUrl = "".concat(svs.utils.urlMapping.get('marketplace')).concat(getTeamUrl(marketplaceAccount.groupId, marketplaceAccount.name, 'spel', marketplaceAccount.containerId, marketplaceAccount.activatedDrawId));
    }

    var transferTo = {
      abortAction: svs.tipset.models.wager.handleTransferActions,
      transferAction: function transferAction() {
        svs.components.dialog.api.close();

        _this2.trigger('transferWager', _this2.wagerToTransfer);
      }
    };
    var currentGameId = this.get('id');

    if (!svs.tipset.data.isRetailerAdmin && !marketplaceAccount && !svs.tipset.models.play.get('isReduceMode') && svs.tipset.models.transferWager && svs.tipset.models.transferWager.get('hasDrawToTransferTo') && currentGameId !== 'T8' && currentGameId !== 'POWERPLAY' && !this.wasWagerTransferredFromOtherGame && !(window.location.href.indexOf('tipssm') > -1)) {
      transferTo.gameName = svs.tipset.models.transferWager.get('gameName');
    }

    getPaymentDoneMessage({
      amount: amount,
      tipsetBombenAmount: bombenAmount,
      productName: this.getProductName(),
      compDesc: compDesc,
      competitionSignUp: competitionSignUp,
      marketplaceUrl: marketplaceUrl,
      isRetailer: svs.tipset.data.isRetailerAdmin,
      transferTo: transferTo
    }, function (messageObject) {
      setTimeout(function () {
        svs.components.dialog.api.add(new svs.components.dialog.Confirm(messageObject.paymentDoneDialogConfig));

        if (messageObject.transferDialogConfig) {
          svs.components.dialog.api.add(new svs.components.dialog.Confirm(messageObject.transferDialogConfig));
        }
      }, 500);
    });

    if (marketplaceAccount) {
      svs.components.marketplace.accountSelector.helpers.fetchGames({
        drawNumber: svs.tipset.collections.draws.getCurrentDraw().get('drawNumber'),
        productId: svs.tipset.collections.draws.getCurrentDraw().get('productId'),
        options: {
          ignoreCache: true
        }
      });
    }
  },
  getWagerProps: function getWagerProps() {
    var hasSystem = svs.tipset.models.systems && svs.tipset.models.systems.getCurrentSystem(),
        extradata = {};
    var marketplaceAccount = getMarketplaceAccount();
    var currentSystemName,
        hasQuickPick = false,
        quickPickValue;

    if (svs.tipset.models.play.get('isReduceMode')) {
      currentSystemName = "reducera fritt ".concat(svs.tipset.models.reduceFreeContainer.get('rows'));
      hasQuickPick = svs.tipset.models.xpertenSystemsSingleRow && svs.tipset.models.xpertenSystemsSingleRow.get('quickPick') !== svs.tipset.constants.NO_QP;
      quickPickValue = hasQuickPick ? svs.tipset.models.xpertenSystemsSingleRow.get('quickPick') : undefined;
    } else if (svs.tipset.models.play.get('isSingleRow')) {
      currentSystemName = '';
      hasQuickPick = svs.tipset.models.xpertenSystemsSingleRow && svs.tipset.models.xpertenSystemsSingleRow.get('quickPick') !== svs.tipset.constants.NO_QP;
      quickPickValue = hasQuickPick ? svs.tipset.models.xpertenSystemsSingleRow.get('quickPick') : undefined;
    } else {
      currentSystemName = hasSystem ? svs.tipset.models.systems.getSystemName() : "M ".concat(svs.tipset.collections.matchlist.getNrOfRows());
      hasQuickPick = svs.tipset.models.xpertenSystems && svs.tipset.models.xpertenSystems.get('quickPick') !== svs.tipset.constants.NO_QP;
      quickPickValue = hasQuickPick ? svs.tipset.models.xpertenSystems.get('quickPick') : undefined;
    }

    extradata.system = currentSystemName;

    if (svs.tipset.models.weekPicker && svs.tipset.models.weekPicker.getNumberOfWeeks()) {
      extradata.rounds = svs.tipset.models.weekPicker.getNumberOfWeeks();
    }

    if (hasQuickPick) {
      extradata.quickpick = quickPickValue;
    }

    var competition = svs.tipset.models.competition;
    var wagerprops = {
      productId: this.get('id'),
      message: getPaymentConfirmMessage({
        productName: this.getProductName(),
        amount: this.getPayPrice(),
        tipsetBombenAmount: this.getBombenPrice(),
        competitionSignedUp: this.isPayingCompetition(),
        compDesc: competition ? competition.get('compDesc') : '',
        marketplaceGroup: marketplaceAccount ? marketplaceAccount.name : null,
        isRetailer: svs.tipset.data.isRetailerAdmin
      }),
      betAmount: svs.tipset.models.betslipFooter.getPrice(),
      marketplaceAccount: marketplaceAccount,
      extradata: extradata
    };

    if (svs.utils.ns.isNamespace('svs.tipset.models.competition') && svs.tipset.models.competition.getIsPayingCompetition() && svs.tipset.models.competition.getCompetitionSignUpMode()) {
      wagerprops.competitionSignUp = svs.tipset.models.competition.toJSON();
    }

    return wagerprops;
  },
  getWager: function getWager() {
    var wager = {
      crc: this.get('crc'),
      marketInfo: this.get('marketInfo'),
      bagType: this.get('bagType'),
      bets: this.getBets(),
      drawNum: svs.tipset.collections.draws.getCurrentDraw().get('drawNumber')
    };

    if (svs.tipset.models.competition && svs.tipset.models.competition.getIsPayingCompetition()) {
      wager.competitionId = [svs.tipset.models.competition.getCompetitionId()];
    }

    var marketplaceAcc = getMarketplaceAccount();

    if (marketplaceAcc && (marketplaceAcc.selectedCommissionPercent === 0 || marketplaceAcc.selectedCommissionPercent && marketplaceAcc.selectedCommissionPercent !== marketplaceAcc.originalCommission)) {
      wager.commissionPercent = marketplaceAcc.selectedCommissionPercent;
    }

    return wager;
  },
  getBets: function getBets() {
    var marketplaceAcc = getMarketplaceAccount();
    var sportkryssBet = {};
    var bets = [],
        gameIX2Board = this.getGame1X2Boards(),
        er1X2Board = this.getEr1X2BoardData(),
        numDraws = svs.utils.ns.isNamespace('svs.tipset.models.weekPicker') && svs.tipset.models.weekPicker.getNumberOfWeeks() ? svs.tipset.models.weekPicker.getNumberOfWeeks() : 1,
        rowPriceMulti = svs.utils.ns.isNamespace('svs.tipset.models.betslipExpanded') ? svs.tipset.models.betslipExpanded.get('amount') : this.defaults.rowPriceMulti,
        couponBetObject = {
      productId: this.get('id'),
      betAmountSalesGroup1: svs.utils.format.CurrencyAsJupiterString(svs.tipset.models.betslipFooter.getCouponPrice()),
      betAmountSalesGroup2: '0,00',
      betProperties: this.getBetProperties(),
      drawNum: svs.tipset.collections.draws.getCurrentDraw().get('drawNumber'),
      game1X2Boards: gameIX2Board,
      er1X2BoardData: er1X2Board,
      numDraws: numDraws,
      rowPriceMulti: rowPriceMulti
    };
    var sportKryssWhileMpAcc = marketplaceAcc && svs.core.detect.feature('ft-marketplace-sportkryss') || !marketplaceAcc;

    if (sportKryssWhileMpAcc && svs.tipset.models.sportkryss && svs.tipset.models.sportkryss.getsportkryssWager()) {
      sportkryssBet = svs.tipset.models.sportkryss.getsportkryssWager();
      bets.push(sportkryssBet);
    }

    bets.push(couponBetObject);
    return bets;
  },
  getBetProperties: function getBetProperties() {
    var marketplaceAccount = getMarketplaceAccount();

    if (marketplaceAccount && svs.core.userSession.hasRole(svs.core.userSession.roles.RETAILER)) {
      if (svs.tipset.models.play.get('isReduceMode')) {
        return [svs.tipset.constants.BET_PROPERTIES_MARKETPLACE, svs.tipset.constants.BET_PROPERTIES_MARKETPLACE_RETAIL, svs.tipset.constants.BET_PROPERTIES_FREE_REDUCE];
      }

      return [svs.tipset.constants.BET_PROPERTIES_MARKETPLACE, svs.tipset.constants.BET_PROPERTIES_MARKETPLACE_RETAIL];
    } else if (marketplaceAccount) {
      if (svs.tipset.models.play.get('isReduceMode')) {
        return [svs.tipset.constants.BET_PROPERTIES_MARKETPLACE, svs.tipset.constants.BET_PROPERTIES_FREE_REDUCE];
      }

      return [svs.tipset.constants.BET_PROPERTIES_MARKETPLACE];
    } else if (svs.tipset.models.play.get('isReduceMode')) {
      return [svs.tipset.constants.BET_PROPERTIES_FREE_REDUCE];
    } else if (svs.tipset.models.competition && svs.tipset.models.competition.getIsPayingCompetition()) {
      return new Array(svs.tipset.constants.BET_PROPERTIES_COMPETITION);
    }
  },
  getEr1X2BoardData: function getEr1X2BoardData() {
    if (!svs.tipset.models.play.get('isReduceMode')) {
      return;
    }

    var boards = [],
        reducer = new svs.tipset.freeReduction.Reducer(svs.tipset.collections.matchlist.getWeights(), svs.tipset.models.reduceFreeContainer.get('rows')),
        rows = reducer.reduce(),
        outcomeMapping = {
      1: 1,
      X: 2,
      2: 4
    };

    for (var i = 0; i < rows.length; ++i) {
      var board = '';

      for (var k = 0; k < rows[i].length; ++k) {
        board += outcomeMapping[rows[i][k]];
      }

      boards.push(board);
    }

    return {
      simpleRowsOnly: true,
      boards: boards
    };
  },
  getGame1X2Boards: function getGame1X2Boards() {
    var isSingleRow = svs.tipset.models.play.get('isSingleRow'),
        isReduceMode = svs.tipset.models.play.get('isReduceMode'),
        gameBoardsArr = [];
    var currentSystem,
        systemNum,
        systemType,
        boardData,
        uRowData,
        uSystemBoardObject,
        boardProps = svs.tipset.models.xpertenSystems ? svs.tipset.models.xpertenSystems.get('quickPick') : svs.tipset.constants.NO_QP,
        gameBoardObject,
        boardList = [];

    if (isReduceMode) {
      return;
    } else if (isSingleRow) {
      boardList = svs.tipset.collections.boardCollections.getCompleteBoardsData();
      boardProps = svs.tipset.models.xpertenSystemsSingleRow ? svs.tipset.models.xpertenSystemsSingleRow.get('quickPick') : svs.tipset.constants.NO_QP;

      _.each(boardList, function (board) {
        boardData = svs.tipset.utils.convertBoardToItsData(board.get('boardData'));
        gameBoardObject = {
          boardData: boardData,
          systemNum: 1,
          systemType: 'SROW',
          uRowData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        };

        if (boardProps) {
          gameBoardObject.boardProps = [boardProps];
        }

        gameBoardsArr.push(gameBoardObject);
      });
    } else {
      currentSystem = svs.tipset.models.systems && svs.tipset.models.systems.getCurrentSystem() ? svs.tipset.models.systems.getCurrentSystem() : undefined;
      systemNum = currentSystem ? currentSystem.systemNum : 1;
      systemType = this.getItsSystemType(currentSystem);
      boardData = svs.tipset.utils.convertBoardToItsData(svs.tipset.collections.matchlist.getBoardData());
      uRowData = svs.tipset.collections.matchlist.getURowData();
      gameBoardObject = {
        boardData: boardData,
        systemNum: systemNum,
        systemType: systemType,
        uRowData: uRowData
      };

      if (boardProps) {
        gameBoardObject.boardProps = [boardProps];
      }

      gameBoardsArr.push(gameBoardObject);

      if (currentSystem && currentSystem.type == svs.tipset.constants.SYSTEM_TYPE.U_SYSTEM) {
        uSystemBoardObject = {
          boardData: svs.tipset.utils.convertBoardToItsData(svs.tipset.collections.matchlist.getURowData()),
          systemType: svs.tipset.constants.SYSTEM_TYPE.U_ROW
        };
        gameBoardsArr.push(uSystemBoardObject);
      }
    }

    return gameBoardsArr;
  },
  getItsSystemType: function getItsSystemType(system) {
    var currentSystem = system,
        systemTypes = svs.tipset.constants.ITS_SYSTEM.SYSTEM_TYPES,
        itsSystemType = currentSystem && currentSystem.type ? _.findWhere(systemTypes, {
      systemType: currentSystem.type
    }).itsSystemType : this.getSystemTypeWhenNoSystem();
    return itsSystemType;
  },
  getSystemTypeWhenNoSystem: function getSystemTypeWhenNoSystem() {
    var isMsys = svs.tipset.collections.matchlist.getNrOfHalfHedges() > 0 || svs.tipset.collections.matchlist.getNrOfFullHedges() > 0,
        systemType = isMsys ? svs.tipset.constants.ITS_SYSTEM.MSYS : svs.tipset.constants.ITS_SYSTEM.NO_SYSTEM;
    return systemType;
  },
  getPayPrice: function getPayPrice() {
    if (this.getProductName() === svs.tipset.constants.PRODUCTNAME.POWERPLAY) {
      return parseFloat(svs.tipset.models.betslipFooter.getCouponPrice());
    }

    return svs.tipset.models.betslipFooter.getPrice();
  },
  getBombenPrice: function getBombenPrice() {
    if (this.getProductName() === svs.tipset.constants.PRODUCTNAME.POWERPLAY) {
      return parseFloat(svs.tipset.models.bombenXperten.get('systemSize'));
    }

    return null;
  },
  isPayingCompetition: function isPayingCompetition() {
    var competition = svs.tipset.models.competition;

    if (competition && competition.getIsPayingCompetition()) {
      return svs.competition.Helper.userIsParticipatingInTipsSM();
    }

    return null;
  },
  getProductName: function getProductName() {
    var productName = svs.tipset.models.gameDefinitions.get('productName');

    if (svs.tipset.models.gameDefinitions.get('htmlClass') === 'extratipset' && svs.tipset.data.cms && svs.tipset.data.cms.extratipset) {
      productName = svs.tipset.data.cms.extratipset.productName;
    }

    return productName;
  },
  handleTransferActions: function handleTransferActions(doTransfer) {
    svs.components.dialog.api.close();

    if (doTransfer) {
      this.transferWager.saveTransferGame(this.id);
      var url = "".concat(this.transferTo.link + this.transferWager.draws.first().get('drawNumber'), "?transfer=true");
      window.location = url;
    }

    this.wagerToTransfer = null;
  }
});
 })(window);